export const environment = {
  production: true,
  apiEndpoint: 'https://sispoaback.santacruz-dde.edu.bo/api/',
  auEndpoint: 'https://sispoaback.santacruz-dde.edu.bo/api/',
  PATH_IMAGE: 'https://sispoaback.santacruz-dde.edu.bo/storage/perfilEmployee',

  token: localStorage.getItem('u') == null ? '' : JSON.parse(localStorage.getItem('u')).token

};
